export default {
  add_items: 'Add items',
  remove_items: 'Remove items',
  place_order: 'Place order',
  proceed_to_payment: 'Continue to payment',
  go_to_menu: 'Go to menu',

  toasts: {
    input_errors_found: 'There are some issues with the your order info',
  },

  error_messages: {
    internal_error: {
      title: 'Order unsuccessful 😔',
      description:
        'Unfortunately, there was an unexpected problem with your order, our tech team is already working on it 🛠️.',
    },
  },
};
